import { apiClient } from "../client";
export const quoteRequestsService = {
    /**
     * Create a new quote request
     */
    createQuoteRequest: (data) => apiClient.post("/quote-requests", data).then((res) => res.data),
    /**
     * Update an existing quote request (for auto-save)
     */
    updateQuoteRequest: (id, data) => apiClient.put(`/quote-requests/${id}`, data).then((res) => res.data),
    /**
     * Get a single quote request by ID
     */
    getQuoteRequest: (id) => apiClient.get(`/quote-requests/${id}`).then((res) => res.data),
    /**
     * Get all quote requests for a contact
     */
    getQuoteRequestsByContact: (contactId) => apiClient.get(`/quote-requests/contact/${contactId}`).then((res) => res.data),
    /**
     * Submit a quote request (mark as submitted)
     */
    submitQuoteRequest: (id) => apiClient.post(`/quote-requests/${id}/submit`).then((res) => res.data),
    /**
     * Link a quote to a quote request (when staff creates quote from request)
     */
    linkQuoteToRequest: (quoteRequestId, quoteId) => apiClient.post(`/quote-requests/${quoteRequestId}/link/${quoteId}`).then((res) => res.data),
};
